import React, { useContext, useEffect, useRef, useState } from 'react';
import StatisticsModal from './StatisticsModal';
import Chart from 'chart.js/auto';
import zoomPlugin from 'chartjs-plugin-zoom';

import {
  getContentsList,
  getContentsStatisticsByTime,
} from '../../modules/NetworkFunction';
import * as XLSX from 'xlsx';
import '../../index.css';
import AuthContext from '../../contexts/AuthContext';
import ShopModeContext from '../../contexts/ShopModeContext';
import StatisticsSelectItemModal from './StatisticsSelectItemModal';
import deleteIcon from '../../icons/ic-item-delete.png';

Chart.register(zoomPlugin);

let MultiChart;

function PopularContents() {
  const { auth: token } = useContext(AuthContext);
  const { shopMode } = useContext(ShopModeContext);

  const year = new Date().getFullYear(); // 년
  const month = new Date().getMonth(); // 월
  const day = new Date().getDate(); // 일

  const [date1, setDate1] = useState(new Date(year, month, day - 5));
  const [date2, setDate2] = useState(new Date(year, month, day + 1));

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [excelDateList, setExcelDateList] = useState([]);
  const [excelNumList, setExcelNumList] = useState([]);

  const startDateRef = useRef(null);
  const endDateRef = useRef(null);

  const [isContentsLoaded, setIsContentsLoaded] = useState(false);
  const [selectedContentsList, setSelectedContentsList] = useState([]);
  const [contentsList, setContentsList] = useState([]);
  const [isSelected, setIsSelected] = useState(false);

  const [noContent, setNoContent] = useState(true);
  const [drawLoading, setDrawLoading] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectModalOpen, setSelectModalOpen] = useState(false);

  const userNo = window.sessionStorage.getItem('userNo');

  useEffect(() => {
    startDateRef.current.value = date1.toISOString().substring(0, 10);
    endDateRef.current.value = date2.toISOString().substring(0, 10);

    setStartDate(date1.toISOString().substring(0, 10));
    setEndDate(date2.toISOString().substring(0, 10));

    
      getContentsList(
        { 
          itemsPerPage: 100,
          shopMode,
          userNo,
          flag: true
        },
        (v) => {
          setContentsList(v);
        },
        setIsContentsLoaded,
        (e) => {
          console.log('error!');
        },
        token
      );

      setSelectedContentsList([]);
      
    
  }, [date1, date2, day, isContentsLoaded, shopMode, token]);

  // 맨 처음 그래프 세팅
  // 최근 일주일
  useEffect(() => {
    buildMultiChart([], true);
  }, []);

  const buildMultiChart = (dataArray, isDefault) => {
    let ctx = document.getElementById('MultiChart').getContext('2d');
    const existingChart = Chart.getChart('MultiChart');
    if (existingChart) {
      existingChart.destroy();
    }

    if (!isDefault) {
      let labelData = [];
      let countData = [];
      let totalData = [];
      let maxCount = 0;

      dataArray[0].map((subData) => {
        subData.counts.map((c, index) => {
          let month = subData.date.split('-')[1];
          let day = subData.date.split('-')[2];

          if (index == 0) {
            labelData.push(month + '/' + day + '심야');
          } else if (index == 1) {
            labelData.push(month + '/' + day + '오전');
          } else if (index == 2) {
            labelData.push(month + '/' + day + '오후');
          } else {
            labelData.push(month + '/' + day + '저녁');
          }
        });
      });

      dataArray.map((contentsData) => {
        let clist = [];
        contentsData.map((content) => {
          let newCounts = [];
          newCounts.push(content.counts.find((c) => c.hourgroup === '심야'));
          newCounts.push(content.counts.find((c) => c.hourgroup === '오전'));
          newCounts.push(content.counts.find((c) => c.hourgroup === '오후'));
          newCounts.push(content.counts.find((c) => c.hourgroup === '저녁'));
          newCounts.map((c, index) => {
            clist.push(c.count);
            if (c.count > maxCount) maxCount = c.count;
          });
        });
        countData.push(clist);
      });

      setExcelNumList(countData);
      setExcelDateList(labelData);

      let finalData = dataArray.map((contentsData, index) => {
        let color = '#' + Math.round(Math.random() * 0xffffff).toString(16);
        return {
          type: 'line',
          label: contentsData[0].title || '제목 없음',
          data: countData[index],
          fill: false,
          backgroundColor: color,
          borderColor: color,
          tension: 0.1,
          pointStyle: 'circle',
          pointRadius: 3.5,
          pointBackgroundColor: color,
        };
      });

      countData[0].map((c) => {
        totalData.push(0);
      });
      countData.map((arr) => {
        arr.map((a, index) => {
          totalData[index] += a;
        });
      });

      finalData.push({
        type: 'bar',
        label: '전체 조회수',
        data: totalData,
        fill: true,
        backgroundColor: '#CCCCCC',
        tension: 0.1,
      });

      MultiChart = new Chart(ctx, {
        data: {
          labels: labelData,
          datasets: finalData,
        },
        options: {
          grouped: false,

          scales: {
            x: {
              grid: {
                display: false,
              },
            },
            y: {
              min: 0,
              max: maxCount,
            },
          },
          animation: {
            duration: 750,
          },
          plugins: {
            legend: {
              labels: {
                usePointStyle: true,
              },
              position: 'bottom',
            },
            datalabels: {
              display: false, // 데이터 라벨 숨기기
            },
          },
          // plugins: {
          //     zoom: {
          //         zoom: {
          //             wheel: {
          //                 enabled: true,
          //             },
          //             pinch: {
          //                 enabled: true
          //             },
          //             mode: 'xy',
          //         },
          //     }
          // }
        },
      });
    } else {
      let firstLabel = [];
      let firstData = [];

      let btMs = date2.getTime() - date1.getTime();
      let btDay = btMs / (1000 * 60 * 60 * 24);
      for (let i = btDay; i >= 0; i--) {
        let monthData = new Date(year, month, day - i).getMonth() + 1;
        let dayData = new Date(year, month, day - i).getDate();

        firstLabel.push(monthData + '/' + dayData + '심야');
        firstLabel.push(monthData + '/' + dayData + '오전');
        firstLabel.push(monthData + '/' + dayData + '오후');
        firstLabel.push(monthData + '/' + dayData + '저녁');

        firstData.push(0);
        firstData.push(0);
        firstData.push(0);
        firstData.push(0);
      }

      MultiChart = new Chart(ctx, {
        data: {
          labels: firstLabel,
          datasets: [
            {
              type: 'bar',
              label: '',
              data: firstData,
              fill: true,
              backgroundColor: '#CCCCCC',
              tension: 0.1,
            },
          ],
        },
        options: {
          scales: {
            x: {
              grid: {
                display: false,
              },
            },
            y: {
              min: 0,
              max: 100,
            },
          },
          animation: {
            duration: 750,
          },
          plugins: {
            legend: {
              display: false,
            },
            datalabels: {
              display: false, // 데이터 라벨 숨기기
            },
          },
        },
      });
    }
  };

  const makeExcel_PopularContents = () => {
    if (
      selectedContentsList.length === 0 ||
      excelDateList.length === 0 ||
      excelNumList.length === 0
    ) {
      alert('조회된 콘텐츠가 없어 빈 엑셀 파일을 생성합니다.');
    }

    const wsData = [];

    const header = ['콘텐츠명', '날짜', '조회수'];
    wsData.push(header);

    if (
      selectedContentsList.length === 0 ||
      excelDateList.length === 0 ||
      excelNumList.length === 0
    ) {
      wsData.push(['-', '-', '-']);
    } else {
      for (let i = 0; i < excelNumList.length; i++) {
        for (let j = 0; j < excelDateList.length; j++) {
          wsData.push([
            selectedContentsList[i].title,
            excelDateList[j],
            excelNumList[i][j],
          ]);
        }
      }
    }

    const worksheet = XLSX.utils.aoa_to_sheet(wsData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, '콘텐츠별 조회수');

    XLSX.writeFile(workbook, '콘텐츠별 인기 상품.xlsx');
  };

  const drawChart = () => {
    let chartNoList = [];

    selectedContentsList.forEach((content) =>
      chartNoList.push(content.contentsNo)
    );

    if (chartNoList.length == 0) {
      alert('원하시는 콘텐츠 선택후, 결과보기를 누르십시오.');
      setDrawLoading(false);
      return;
    } else if (startDate === '' || endDate === '') {
      alert('분석기간을 선택해 주시기 바랍니다.');
      setDrawLoading(false);
      return;
    } else if (endDate < startDate) {
      alert('끝 날짜가 시작 날짜보다 앞서면 안됩니다.');
      setDrawLoading(false);
      return;
    }

    setNoContent(false);
    setDrawLoading(true);

    getContentsStatisticsByTime(
      { contentsNoList: [...chartNoList], startDate, endDate },
      (v) => {
        // 하루씩 + 가 되어버림
        // 21일저녁꺼가 22일 저녁으로 되어버림...

        if (v.results.length > 0) {
          buildMultiChart(v.results, false);
          setDrawLoading(false);
        } else {
          setNoContent(true);
          setDrawLoading(false);
          alert('조회할 데이터가 없습니다.');
          return;
        }
      },
      () => {},
      (e) => {
        console.log('error!');
      },
      token
    );
  };

  const eraseContent = (contentsNo) => {
    setSelectedContentsList((prev) =>
      prev.filter((content) => content.contentsNo !== contentsNo)
    );
  };

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const openSelectModal = () => {
    setSelectModalOpen(true);
    setIsSelected(false);
  };

  const closeSelectModal = () => {
    setSelectModalOpen(false);
  };

  const showContents = () => {
    if (selectedContentsList.length === 0) {
      alert('콘텐츠를 선택해주시길 바랍니다.');
    } else {
      setSelectModalOpen(false);
      setIsSelected(true);
    }
  };

  const selectContentsHandler = (contentsNo) => {
    const existingSelectedContents = selectedContentsList.find(
      (contents) => contents.contentsNo === contentsNo
    );

    if (existingSelectedContents) {
      eraseContent(contentsNo);
    } else {
      setSelectedContentsList((prev) => [
        ...prev,
        contentsList.find((contents) => contents.contentsNo == contentsNo),
      ]);
    }
  };

  const selectAllContentsHandler = () => {
    if (selectedContentsList.length === contentsList.length) {
      setSelectedContentsList([]);
    } else {
      setSelectedContentsList(contentsList);
    }
  };

  return (
    <div>
      <StatisticsModal
        open={modalOpen}
        close={closeModal}
        header="콘텐츠별 인기 상품"
      />
      {isContentsLoaded && selectModalOpen && (
        <StatisticsSelectItemModal
          itemType={'contents'}
          save={showContents}
          open={selectModalOpen}
          close={closeSelectModal}
          header="콘텐츠 선택"
          itemList={contentsList}
          shopMode="cafe24"
          onSelectItem={selectContentsHandler}
          onSelectAllItem={selectAllContentsHandler}
          selectedItemList={selectedContentsList}
        />
      )}

      <p
        style={{
          fontSize: 30,
          fontWeight: '400',
          marginTop: '16px',
          marginBottom: '16px',
        }}
      >
        콘텐츠별 인기 상품
      </p>

      <div
        style={{
          border: '0.5px solid #848484',
          width: '788px',
          marginBottom: '40px',
        }}
      ></div>

      <div style={{ display: 'flex' }}>
        <div style={{ display: 'flex', marginRight: 10, alignItems: 'center' }}>
          <div
            style={{
              display: 'flex',
              width: '80px',
              height: '36px',
              background: '#CCCCCC',
              borderRadius: '10px',
              justifyContent: 'center',
              alignItems: 'center',
              fontWeight: '400',
              fontSize: '16px',
            }}
          >
            동영상
          </div>

          <div style={{ width: '12px' }}></div>

          <button
            onClick={openSelectModal}
            style={{
              width: '175px',
              height: '36px',
              borderRadius: '5px',
              cursor: 'pointer',
              marginRight: '18px',
              border: 0,
              outline: 0,
              backgroundColor: 'rgba(231, 231, 231, 0.45)',
              color: '#B5B5B5',
              fontSize: 14,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
            title={
              selectedContentsList.length > 0
                ? selectedContentsList.map((item) => item.title).join(', ')
                : '콘텐츠를 선택해주세요'
            }
          >
            {selectedContentsList.length > 0
              ? selectedContentsList
                  .map((item) => item.title)
                  .join(', ')
                  .slice(0, 30) +
                (selectedContentsList
                  .map((item) => item.title)
                  .join(', ').length > 30
                  ? '...'
                  : '')
              : '콘텐츠를 선택해주세요'}
          </button>
          <div style={{ width: '12px' }}></div>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                display: 'flex',
                width: '80px',
                height: '36px',
                background: '#CCCCCC',
                borderRadius: '10px',
                justifyContent: 'center',
                alignItems: 'center',
                fontWeight: '400',
                fontSize: '16px',
              }}
            >
              분석 기간
            </div>

            <div style={{ width: '12px' }}></div>

            {/*state이용해서 그래프 그리기*/}
            <input
              type="date"
              ref={startDateRef}
              onChange={(event) => {
                setStartDate(event.target.value);
              }}
              max={endDate}
            />

            <p
              style={{
                margin: '0px 10px',
                color: '#CCCCCC',
              }}
            >
              ~
            </p>

            <input
              type="date"
              ref={endDateRef}
              onChange={(event) => {
                setEndDate(event.target.value);
              }}
              min={startDate}
            />
          </div>

          <div
            className="btn-result"
            onClick={() => {
              drawChart();
            }}
          >
            결과보기
          </div>
        </div>
        <div style={{ width: '12px' }}></div>
      </div>
      <div
        style={{
          display: 'flex',
          width: '100%',
          flexWrap: 'wrap',
          marginTop: '20px',
          marginBottom: '20px',
        }}
      >
        {isSelected &&
          selectedContentsList.map((content) => {
            return (
              <div
                key={content.contentsNo}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '5px',
                  marginBottom: '5px',
                  fontSize: '12px',
                  border: '1px solid #FFB600',
                  borderRadius: '48px',
                  padding: '1px 3px 1px 9px',
                }}
              >
                <div
                  style={{
                    color: '#4D4D4D',
                  }}
                >
                  {content.title}
                </div>
                <div style={{ cursor: 'pointer' }}>
                  <img
                    style={{ display: 'block' }}
                    src={deleteIcon}
                    onClick={() => {
                      eraseContent(content.contentsNo);
                    }}
                    alt="삭제 버튼"
                  />
                </div>
              </div>
            );
          })}
      </div>

      <div
        style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {noContent && (
          <div
            style={{
              position: 'absolute',
              color: '#848484',
              fontSize: '24px',
              paddingBottom: '40px',
            }}
          >
            선택한 콘텐츠가 없습니다.
          </div>
        )}
        {drawLoading && (
          <div
            style={{
              position: 'absolute',
              color: '#848484',
              fontSize: '24px',
              paddingBottom: '40px',
            }}
          >
            불러오는 중...
          </div>
        )}
        <canvas id="MultiChart" width="1000" height="400" />
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'right',
          marginTop: '20px',
        }}
      >
        <p style={{ fontSize: '14px', color: '#B5B5B5' }}>* 시간대 분류</p>
        <div style={{ width: '20px' }}></div>
        <p style={{ color: '#B5B5B5', fontSize: '12px' }}>
          {' '}
          심야 : 24 ~ 06시 오전 : 06 ~ 12시 오후 : 12 ~ 18시 저녁 : 18 ~ 24시{' '}
        </p>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'right',
          marginTop: '10px',
        }}
      >
        <p style={{ size: '2px', color: '#B5B5B5', fontSize: '12px' }}>
          {' '}
          * 그래프 밑부분의 콘텐츠 제목을 누르면 그래프에서 결과 삭제 가능{' '}
        </p>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'right',
          marginTop: '10px',
        }}
      >
        <p style={{ fontSize: '12px', size: '2px', color: '#B5B5B5' }}>
          * 동그라미 부분에 커서를 올리면 상세 조회수 확인 가능
        </p>
      </div>

      <div
        style={{ display: 'flex', justifyContent: 'right', marginTop: '20px' }}
      >
        <span
          style={{
            color: '#FF7A00',
            fontWeight: 'bold',
            marginTop: '10px',
            paddingRight: '10px',
            fontSize: '16px',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          onClick={openModal}
        >
          예시 결과 보기
        </span>
        <span
          style={{
            color: '#FF7A00',
            fontWeight: 'bold',
            marginTop: '10px',
            fontSize: '16px',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          onClick={() => {
            makeExcel_PopularContents();
          }}
        >
          전체 내역 다운 받기
        </span>
      </div>
    </div>
  );
}

export default PopularContents;
